var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 30.9847C23.9199 30.9847 30.3402 24.5645 30.3402 16.6447C30.3402 8.72492 23.9199 2.30469 16.0002 2.30469C8.08039 2.30469 1.66016 8.72492 1.66016 16.6447C1.66016 24.5645 8.08039 30.9847 16.0002 30.9847Z",
    fill: "#D68F30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63477 20.3701V21.8351C2.78477 22.2226 2.95227 22.6051 3.13477 22.9751V20.3701H2.63477Z",
    fill: "#BC6F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27051 23.1274V24.8874C4.47051 25.1699 4.67801 25.4474 4.89551 25.7149V23.1274H4.27051Z",
    fill: "#BC6F00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43555 25.4277V27.3252C6.67805 27.5427 6.92805 27.7502 7.18555 27.9502V25.4277H6.43555Z",
    fill: "#BC6F00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09961 27.1753V29.2153C9.34461 29.3503 9.59461 29.4778 9.84961 29.6003V27.1753H9.09961Z",
    fill: "#BC6F00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.123 28.2876V30.4476C12.3705 30.5176 12.6205 30.5801 12.873 30.6376V28.2876H12.123Z",
    fill: "#BC6F00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6602 28.6729V30.9754C15.7727 30.9779 15.8852 30.9829 16.0002 30.9829C16.1377 30.9829 16.2752 30.9754 16.4102 30.9729V28.6729H15.6602Z",
    fill: "#BC6F00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1973 28.27V30.62C19.4498 30.5625 19.6998 30.4975 19.9473 30.4275V28.27H19.1973Z",
    fill: "#BC6F00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2129 27.1426V29.5701C22.4679 29.4476 22.7179 29.3151 22.9629 29.1776V27.1426H22.2129Z",
    fill: "#BC6F00"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8701 25.3799V27.9049C25.1275 27.7038 25.3776 27.4936 25.6201 27.2749V25.3799H24.8701Z",
    fill: "#BC6F00"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7725 23.0723H27.1475V25.6598C27.365 25.3898 27.575 25.1123 27.7725 24.8273V23.0723Z",
    fill: "#BC6F00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3975 20.3047H28.8975V22.9147C29.08 22.5372 29.2475 22.1497 29.3975 21.7572V20.3047Z",
    fill: "#BC6F00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 29.6946C23.9199 29.6946 30.3402 23.2744 30.3402 15.3546C30.3402 7.43488 23.9199 1.01465 16.0002 1.01465C8.08039 1.01465 1.66016 7.43488 1.66016 15.3546C1.66016 23.2744 8.08039 29.6946 16.0002 29.6946Z",
    fill: "#FFF176"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0625 28.792C23.2767 28.792 29.125 22.9437 29.125 15.7295C29.125 8.51527 23.2767 2.66699 16.0625 2.66699C8.84828 2.66699 3 8.51527 3 15.7295C3 22.9437 8.84828 28.792 16.0625 28.792Z",
    fill: "#F2BC1A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_362_5172)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1467 16.5898C21.1266 15.7506 20.8969 14.9296 20.4783 14.2009C20.0597 13.4723 19.4654 12.8589 18.7491 12.4162C18.0328 11.9735 17.217 11.7155 16.3754 11.6654C15.5339 11.6153 14.693 11.7747 13.9288 12.1292V9.06641H11V22.7612H13.9323V16.7057C13.9338 16.1516 14.152 15.6199 14.5406 15.2234C14.9292 14.8268 15.4577 14.5965 16.014 14.5815C16.5702 14.5664 17.1105 14.7677 17.5202 15.1426C17.9299 15.5176 18.1768 16.0367 18.2086 16.5898V22.7612H21.1467V16.5898Z",
    fill: "#B17707"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91309 15.8551C2.82059 14.1351 3.11809 12.3901 3.71809 10.7551C4.34309 9.12508 5.30059 7.61758 6.50809 6.33758C8.93309 3.77258 12.4531 2.28508 16.0006 2.26758C19.5481 2.28758 23.0706 3.77258 25.4906 6.34008C26.7006 7.61758 27.6556 9.12758 28.2806 10.7551C28.8831 12.3926 29.1806 14.1351 29.0856 15.8551H29.0356C29.0307 14.1392 28.691 12.4408 28.0356 10.8551C27.379 9.27112 26.4204 7.83014 25.2131 6.61258C24.0051 5.39622 22.5694 4.42951 20.9881 3.76758C19.4073 3.10754 17.7112 2.76768 15.9981 2.76768C14.285 2.76768 12.5889 3.10754 11.0081 3.76758C9.42673 4.42951 7.99111 5.39622 6.78309 6.61258C5.57499 7.82948 4.61621 9.27062 3.96059 10.8551C3.30518 12.4408 2.9655 14.1392 2.96059 15.8551H2.91309Z",
    fill: "#E08F00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 1.01758C8.08016 1.01758 1.66016 7.43758 1.66016 15.3576C1.66016 23.2776 8.08016 29.6976 16.0002 29.6976C23.9202 29.6976 30.3402 23.2776 30.3402 15.3576C30.3402 7.43758 23.9202 1.01758 16.0002 1.01758ZM16.0002 28.4201C8.78516 28.4201 2.93766 22.5726 2.93766 15.3576C2.93766 8.14008 8.78516 2.29258 16.0002 2.29258C23.2152 2.29258 29.0627 8.14008 29.0627 15.3551C29.0627 22.5701 23.2152 28.4201 16.0002 28.4201Z",
    fill: "#FFF176"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49801 5.33691L9.81551 6.31941L10.8505 5.92441V6.31941L10.013 6.92691L10.333 7.51191V7.90941L9.49801 7.30191L8.66051 7.90941V7.51191L8.98051 6.92691L8.14551 6.31941V5.92441L9.17801 6.31941L9.49801 5.33691Z",
    fill: "#D38200"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50289 10.9775L5.82289 11.96L6.85539 11.565V11.96L6.02039 12.5675L6.34039 13.155V13.55L5.50289 12.9425L4.66789 13.55V13.155L4.98789 12.5675L4.15039 11.96V11.565L5.18539 11.96L5.50289 10.9775Z",
    fill: "#D38200"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3857 17.9297L5.7057 18.9122L6.7382 18.5172V18.9122L5.9032 19.5197L6.2232 20.1072V20.5022L5.3857 19.8947L4.5507 20.5022V20.1072L4.8707 19.5197L4.0332 18.9122V18.5172L5.0682 18.9122L5.3857 17.9297Z",
    fill: "#D38200"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65035 23.4497L9.97035 24.4322L11.0029 24.0372V24.4322L10.1679 25.0397L10.4879 25.6247V26.0222L9.65035 25.4147L8.81535 26.0222V25.6247L9.13535 25.0397L8.29785 24.4322V24.0372L9.33285 24.4322L9.65035 23.4497Z",
    fill: "#D38200"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5029 5.33691L22.1854 6.31941L21.1504 5.92441V6.31941L21.9879 6.92691L21.6679 7.51191V7.90941L22.5029 7.30191L23.3404 7.90941V7.51191L23.0204 6.92691L23.8554 6.31941V5.92441L22.8229 6.31941L22.5029 5.33691Z",
    fill: "#D38200"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.498 10.9775L26.178 11.96L25.1455 11.565V11.96L25.9805 12.5675L25.6605 13.155V13.55L26.498 12.9425L27.333 13.55V13.155L27.013 12.5675L27.8505 11.96V11.565L26.8155 11.96L26.498 10.9775Z",
    fill: "#D38200"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6152 17.9297L26.2952 18.9122L25.2627 18.5172V18.9122L26.0977 19.5197L25.7777 20.1072V20.5022L26.6152 19.8947L27.4502 20.5022V20.1072L27.1302 19.5197L27.9677 18.9122V18.5172L26.9327 18.9122L26.6152 17.9297Z",
    fill: "#D38200"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3505 23.4497L22.0305 24.4322L20.998 24.0372V24.4322L21.833 25.0397L21.513 25.6247V26.0222L22.3505 25.4147L23.1855 26.0222V25.6247L22.8655 25.0397L23.703 24.4322V24.0372L22.668 24.4322L22.3505 23.4497Z",
    fill: "#D38200"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3505 23.0522L22.668 24.0347H23.703L22.8655 24.6422L23.1855 25.6247L22.3505 25.0172L21.513 25.6247L21.833 24.6422L20.998 24.0347H22.0305L22.3505 23.0522Z",
    fill: "#FFF176"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6152 17.5347L26.9327 18.5172H27.9677L27.1302 19.1247L27.4502 20.1072L26.6152 19.4997L25.7777 20.1072L26.0977 19.1247L25.2627 18.5172H26.2952L26.6152 17.5347Z",
    fill: "#FFF176"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.498 10.582L26.8155 11.5645H27.8505L27.013 12.172L27.333 13.1545L26.498 12.547L25.6605 13.1545L25.9805 12.172L25.1455 11.5645H26.178L26.498 10.582Z",
    fill: "#FFF176"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5029 4.93945L22.8229 5.92195H23.8554L23.0204 6.52945L23.3404 7.51195L22.5029 6.90445L21.6679 7.51195L21.9879 6.52945L21.1504 5.92195H22.1854L22.5029 4.93945Z",
    fill: "#FFF176"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0127 25.6245L16.3327 26.607L17.3652 26.212V26.607L16.5302 27.2145L16.8502 27.802V28.197L16.0127 27.5895L15.1777 28.197V27.802L15.4977 27.2145L14.6602 26.607V26.212L15.6952 26.607L16.0127 25.6245Z",
    fill: "#D38200"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0127 25.0996L16.3327 26.0821H17.3652L16.5302 26.6896L16.8502 27.6721L16.0127 27.0646L15.1777 27.6721L15.4977 26.6896L14.6602 26.0821H15.6952L16.0127 25.0996Z",
    fill: "#FFF176"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0127 3.22217L16.3327 4.20467L17.3652 3.80967V4.20467L16.5302 4.81217L16.8502 5.39967V5.79467L16.0127 5.18717L15.1777 5.79467V5.39967L15.4977 4.81217L14.6602 4.20467V3.80967L15.6952 4.20467L16.0127 3.22217Z",
    fill: "#D38200"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0127 2.82715L16.3327 3.80965H17.3652L16.5302 4.41715L16.8502 5.39965L16.0127 4.79215L15.1777 5.39965L15.4977 4.41715L14.6602 3.80965H15.6952L16.0127 2.82715Z",
    fill: "#FFF176"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65035 23.0522L9.33285 24.0347H8.29785L9.13535 24.6422L8.81535 25.6247L9.65035 25.0172L10.4879 25.6247L10.1679 24.6422L11.0029 24.0347H9.97035L9.65035 23.0522Z",
    fill: "#FFF176"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3857 17.5347L5.0682 18.5172H4.0332L4.8707 19.1247L4.5507 20.1072L5.3857 19.4997L6.2232 20.1072L5.9032 19.1247L6.7382 18.5172H5.7057L5.3857 17.5347Z",
    fill: "#FFF176"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50289 10.582L5.18539 11.5645H4.15039L4.98789 12.172L4.66789 13.1545L5.50289 12.547L6.34039 13.1545L6.02039 12.172L6.85539 11.5645H5.82289L5.50289 10.582Z",
    fill: "#FFF176"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49801 4.93945L9.17801 5.92195H8.14551L8.98051 6.52945L8.66051 7.51195L9.49801 6.90445L10.333 7.51195L10.013 6.52945L10.8505 5.92195H9.81551L9.49801 4.93945Z",
    fill: "#FFF176"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_362_5172",
    x: 11,
    y: 9.06641,
    width: 10.1465,
    height: 13.6948,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.7375 0 0 0 0 0.494829 0 0 0 0 0.0350313 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_362_5172"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.cc4faa6190e41faa5932233814a2304f.svg";
export { ForwardRef as ReactComponent };